import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_med_a">
              <div className="_tit">구분</div>
            </div>
            <div className="_col _col_med_b _bor_l">
              <div className="_tit">대상의료비</div>
            </div>
            <div className="_col _col_med_c _bor_l">
              <div className="_tit">공제대상금액</div>
            </div>
            <div className="_col _col_med_d _bor_l">
              <div className="_tit">세액공제</div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_med_a_set">
              <div className="_row">
                <div className="_col _col_med_a">
                  <div className="_cont">① 의료비 기본공제</div>
                </div>
                <div className="_col _col_med_b _bor_l">
                  <div className="_cont">
                    인.장애인.65세 이상 자, 장애인, 건강보험산정특례자(중증질환자, 희귀난치성질환자,
                    결핵환자)를 위하여 지급한 의료비
                  </div>
                </div>
                <div className="_col _col_med_c _bor_l">
                  <div className="_cont _left">해당(기본) 의료비 전액</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_med_a">
                  <div className="_cont">② 의료비 추가공제</div>
                </div>
                <div className="_col _col_med_b _bor_l">
                  <div className="_cont">
                    위 이외의 기본공제대상자(연령, 소득요건 불문)를 위하여 지급한 의료비
                  </div>
                </div>
                <div className="_col _col_med_c _bor_l">
                  <div className="_cont _left">
                    Min(㉠,㉡) ㉠ 해당(추가) 의료비－(총급여액×3%) ㉡ 연 700만원
                  </div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_med_a">
                  <div className="_cont">③ 미숙아, 선천성이상아 의료비</div>
                </div>
                <div className="_col _col_med_b _bor_l">
                  <div className="_cont">미숙아 및 선천성이상아를 위하여 지급한 의료비</div>
                </div>
                <div className="_col _col_med_c _bor_l">
                  <div className="_cont _left">해당(미숙아, 선천성이상아) 의료비 전액</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_med_a">
                  <div className="_cont">④ 난임시술비</div>
                </div>
                <div className="_col _col_med_b _bor_l">
                  <div className="_cont">난임시술을 위하여 지급한 의료비</div>
                </div>
                <div className="_col _col_med_c _bor_l">
                  <div className="_cont _left">해당(난임시술비) 의료비 전액</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_med_a">
                  <div className="_cont">공제대상금액 (①+②+③+④)</div>
                </div>
                <div className="_col _col_med_c_set _bor_l">
                  <div className="_cont">
                    의료비 추가공제금액이 (-)금액인 경우에도 의료비 기본공제금액과 그대로 합산
                    <br /> (①과 ②의 공제금액을 먼저 합산하고,
                    <br /> 그 합산한 금액이 (-)금액인 경우 ③에서 그 금액을 차감하며,
                    <br /> ①과 ②,③의 공제금액을 합산한 금액이 (-)금액인 경우
                    <br /> ④에서 그 금액을 차감)
                  </div>
                </div>
              </div>
            </div>
            <div className="_col _col_med_d _bor_l">
              <div className="_cont _mid">
                공제대상금액의 15% (미숙아, 선천성이상아 의료비 20%, 난임시술비 30%)
              </div>
            </div>
          </div>
          {/* <div className="_row">
            <div className="_col _col_se_3">
              <div className="_cont">
                장애인전용
                <br />
                보장성보험료
              </div>
            </div>
            <div className="_col _col_se_4">
              <div className="_cont">
                기본공제대상자 중 장애인을 피보험자 또는 수익자로 하는 장애인전용보험으로서
                생명보험, 상해보험, 손해보험, 각종 공제, 주택 임차보증금 반환 보증보험
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">
                보험료의 합계액
                <br />
                기준 연 100만원
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">
                지급금액과 100만원 중<br />
                적은 금액
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont"> 공제대상금액의 15%</div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
